export class ServiceCompany {
    constructor(
        id,
        name,
        CIF,
        deletedAt
    ) {
        this.id = id;
        this.name = name;
        this.CIF = CIF;
        this.deletedAt = deletedAt;
    }

    static createFormResponseData(data) {
        return new ServiceCompany(

            data.id,
            data.name,
            data.CIF,
            data.deletedAt
        );
    }
}